<template>
  <div class="SingleInputor">
    <div class="p-lable">{{ propertyData[propertyDataKey].lable }}</div>
    <div class="p-singlecolorselector-wrap" v-if="!isObjectValue">
      <el-input v-model="value" @change="handleChange" placeholder="请输入"></el-input>
    </div>
    <div class="p-object-wrap" v-else>
      <div class="p-object-item" v-if="objectValue.enabledLabel">
        <span class="p-config">{{ objectValue.enabledLabel }}</span>
        <el-switch v-model="objectValue.enabled" @change="handleObjectChange" size="mini" />
      </div>
      <div class="p-object-item" v-if="objectValue.itemNameLabel">
        <span class="p-config">{{ objectValue.itemNameLabel }}</span>
        <el-input
          size="mini"
          v-model="objectValue.itemName"
          @change="handleObjectChange"
          placeholder="如：负面"
        ></el-input>
      </div>
      <div class="p-object-item" v-if="objectValue.thresholdLabel">
        <span class="p-config">{{ objectValue.thresholdLabel }}</span>
        <el-input
          size="mini"
          v-model="objectValue.threshold"
          @change="handleObjectChange"
          placeholder=""
        ></el-input>
      </div>
      <div class="p-object-item" v-if="objectValue.linkLabel">
        <span class="p-config">{{ objectValue.linkLabel }}</span>
        <el-input
          size="mini"
          v-model="objectValue.link"
          @change="handleObjectChange"
          placeholder="https://www.baidu.com/"
        ></el-input>
      </div>
      <div class="p-object-item" v-if="objectValue.linkLabel">
        <span class="p-config">链接名称</span>
        <el-input
          size="mini"
          v-model="objectValue.linkName"
          @change="handleObjectChange"
          placeholder="如：百度"
        ></el-input>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'SingleInputor',
  props: {
    CurrentConfigration: Object,
    propertyData: Object,
    propertyDataKey: String,
  },
  data() {
    return {
      value: '',
      objectValue: {
        enabled: false,
        enabledLabel: '',
        itemName: '',
        itemNameLabel: '',
        threshold: 10,
        thresholdLabel: '',
        linkLabel: '',
        link: '',
        linkName: '',
      },
      fontStyle: {},
    };
  },
  computed: {
    isObjectValue() {
      const val = this.propertyData[this.propertyDataKey].value;
      return val !== null && typeof val === 'object' && !Array.isArray(val);
    },
  },
  created() {
    this.fontStyle = this.propertyData[this.propertyDataKey].fontStyle || null;
  },
  mounted() {
    const val = this.propertyData[this.propertyDataKey].value;
    if (this.isObjectValue) {
      this.objectValue = {
        enabled: val.enabled !== undefined && val.enabled !== null ? val.enabled : false,
        enabledLabel: val.enabledLabel !== undefined && val.enabledLabel !== null ? val.enabledLabel : '',
        itemName: val.itemName !== undefined && val.itemName !== null ? val.itemName : '',
        itemNameLabel: val.itemNameLabel !== undefined && val.itemNameLabel !== null ? val.itemNameLabel : '',
        threshold: val.threshold !== undefined && val.threshold !== null ? val.threshold : 10,
        thresholdLabel:
          val.thresholdLabel !== undefined && val.thresholdLabel !== null ? val.thresholdLabel : '',
        linkLabel: val.linkLabel !== undefined && val.linkLabel !== null ? val.linkLabel : '',
        link: val.link !== undefined && val.link !== null ? val.link : '',
        linkName: val.linkName !== undefined && val.linkName !== null ? val.linkName : '',
      };
    } else {
      this.value = val;
    }
  },
  methods: {
    handleChange(val) {
      this.$store.commit('update_PropertyData', {
        key: this.propertyDataKey,
        value: val,
      });
    },
    handleObjectChange() {
      this.$store.commit('update_PropertyData', {
        key: this.propertyDataKey,
        value: { ...this.objectValue },
      });
    },
  },
};
</script>
<style scoped lang="scss">
.SingleInputor {
  width: 100%;
  box-sizing: border-box;

  :deep().el-switch {
    margin: auto 0;
    .el-switch__core {
      background: #55597b;
      border: none;
      height: 10px;
      width: 30px !important;
      .el-switch__action {
        top: -2px;
        background: #c9cae5;
        width: 14px;
        height: 14px;
      }
    }
    &.is-checked {
      .el-switch__core {
        background: linear-gradient(143deg, #335ae9, #6f6ff5);
        .el-switch__action {
          left: 100%;
          background: #ffffff;
          margin-left: -14px;
        }
      }
    }
  }

  .p-lable {
    box-sizing: border-box;
    padding: 0 15px;
    width: 100%;
    height: 30px;
    color: $property-title-color;
    font-size: $property-title-size;
    line-height: 30px;
  }

  .p-singlecolorselector-wrap {
    position: relative;
    box-sizing: border-box;
    display: flex;
    justify-content: center;
    width: 100%;
    height: 40px;
    padding: 0 15px;
    :deep().el-input input {
      height: 35px;
      color: #b6b8cc;
      background: #191b23;
      text-align: center;
      border: 1px solid rgba(139, 139, 139, 0.733);
      &:hover {
        border: 1px solid #3179ff;
      }
      &:focus {
        border: 1px solid #3179ff;
      }
    }
  }

  .p-object-wrap {
    box-sizing: border-box;
    padding: 0 15px 10px;

    .p-object-item {
      position: relative;
      box-sizing: border-box;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      width: 100%;
      height: 35px;

      .el-input {
        width: 70%;
      }

      :deep() input {
        color: #ffffff;
        background: #191b23;
        border-radius: 0;
        padding: 0;
        border-collapse: collapse;
        text-align: center;
        border: 1px solid rgb(90, 90, 90);
        &:hover {
          border: 1px solid #3179ff;
        }
        &:focus {
          border: 1px solid #3179ff;
        }
      }

      .p-config {
        color: $property-attributes-color;
        height: 35px;
        line-height: 35px;
        font-size: $property-attributes-size;
        flex: 1;
      }

      .p-input {
        height: 35px;
        display: flex;
        align-items: center;
      }
    }
  }

  .charts-style-config {
    margin: 5px 0;
    color: $property-attributes-color;
    font-size: $property-attributes-size;
    padding: 0 15px;
    box-sizing: border-box;
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    height: 30px;

    .el-input {
      width: 35px;
      margin-right: 5px;
    }
    span {
      width: 60px;
      box-sizing: border-box;
      padding-left: 5px;
    }

    :deep() input {
      color: #ffffff;
      background: #191b23;
      border-radius: 0;
      border-collapse: collapse;
      text-align: center;
      border: 1px solid rgb(90, 90, 90);
      padding-left: 2px;
      padding-right: 2px;
      &:hover {
        border: 1px solid #3179ff;
      }
      &:focus {
        border: 1px solid #3179ff;
      }
    }
  }
}
</style>
